var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./CommonStoryMembers.jinja');
require('./CommonStoryMembers.less');

var CommonGallery = require('front/components/CommonGallery/CommonGallery');

module.exports = Base.extend({

    template: template,

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'CommonGallery': {selector: '.CommonGallery', viewConstructor: CommonGallery}
    },


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonStory/CommonStoryMembers.js
// module id = 170
// module chunks = 0